import { SubscribeEvent } from 'common/events/subscribeEventTypes'
import { DataLayerEventName } from 'common/helpers/DataLayerEventName'

export function createSubscribeLinkClickEvent(
    originator: 'header' | 'header-nav' | 'footer-nav' | 'flyout-nav',
    onEvent: (event: SubscribeEvent) => void
): () => void {
    const eventPayload: SubscribeEvent['payload'] = {
        paywallType: 'freemium',
        leadDepth: 0,
        creative: undefined,
        breachScreenType: undefined,
        popupMethod: undefined,
        deal: undefined,
        pricepoint: [7, 8],
    }

    return () => {
        onEvent({
            type: DataLayerEventName.subscribeClick,
            originator,
            payload: eventPayload,
        })
    }
}
